import React from "react"
import { ContentfulPage } from "#/features/contentful/contentful-page"
import { StaticAssetID } from "#/lib/contentful/contentfulClient"
import { useFlags } from "launchdarkly-react-client-sdk"

export function MedicalPrimePage(): JSX.Element {
  const { telemedicineForMenopauseContentfulPage } = useFlags()

  return (
    <ContentfulPage entryId={StaticAssetID.MEDICAL_PRIME_PAGE} flagEnabled={telemedicineForMenopauseContentfulPage} />
  )
}
